import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';
import { buildClassNames, buildClassNameModifiers } from '../util/utils';
import './menuItem.scss';

const menuItemClassName = 'menuItem';
const labelIconClassName = 'menuItem__labelIcon';

/** A subcomponent used to render items in a menu */
export class MenuItem extends Component {
  static propTypes = {
    /** @ignore */
    children: renderableType,
    /** @ignore */
    className: PropTypes.string,
    /**
     * @ignore
     * Convenience prop used to determine whether a child
     * component of the Menu component is a MenuItem
     */
    isMenuItem: PropTypes.bool,
    /** Indicates whether the item represents the current selection */
    current: PropTypes.bool,
    /** Indicates whether the item is disabled */
    disabled: PropTypes.bool,
    /** The icon to be rendered next to the label */
    icon: renderableType,
    /** The content displayed for the menu item */
    label: renderableType,
    /** Function executed on click */
    onClick: PropTypes.func,
    /** Text displayed on hover */
    title: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    current: false,
    isMenuItem: true,
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      if (!this.props.disabled) this.props.onClick(e);
    }
  };

  render() {
    const {
      children,
      className,
      isMenuItem,
      current,
      disabled,
      icon,
      label,
      onClick,
      title,
      ...other
    } = this.props;

    const clickHandler = disabled ? undefined : onClick;
    const menuItemClassNames = buildClassNames(
      className,
      buildClassNameModifiers(menuItemClassName, { disabled }, { current }),
      menuItemClassName,
    );

    return (
      <div
        role='menuitem'
        tabIndex={0}
        title={title || label}
        className={menuItemClassNames}
        onClick={clickHandler}
        onKeyDown={this.handleKeyDown}
        {...other}
      >
        <span>
          {icon && cloneElement(icon, { className: labelIconClassName }) }
          {children || label}
        </span>
      </div>
    );
  }
}
